import { render, staticRenderFns } from "./DownloadData.vue?vue&type=template&id=5ba763fd&"
import script from "./DownloadData.vue?vue&type=script&lang=js&"
export * from "./DownloadData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports